const use = (selector) => {
  if (typeof selector == "string") {
    return document.querySelector(`#${selector}`);
  } else {
    return selector;
  }
};
const append = (selector, el) => {
  var _a;
  let container = use(selector);
  if (!container) {
    container = document.createElement("div");
    container.id = selector;
    document.body.appendChild(container);
  } else {
    for (let i = 0, l = ((_a = container == null ? void 0 : container.children) == null ? void 0 : _a.length) || 0; i < l; i++) {
      if (el && (container == null ? void 0 : container.children[i]) == el) return;
    }
  }
  container.appendChild(el);
};
const remove = (selector, el) => {
  var _a;
  const container = use(selector);
  for (let i = 0, l = ((_a = container == null ? void 0 : container.children) == null ? void 0 : _a.length) || 0; i < l; i++) {
    if (el && (container == null ? void 0 : container.children[i]) == el) {
      container.removeChild(el);
      break;
    }
  }
};
const includes = (current, container) => {
  if (!current) return false;
  else if (current == container) {
    return true;
  } else {
    return includes(current.parentElement, container);
  }
};

export { append, includes, remove, use };
//# sourceMappingURL=index.mjs.map
